// interface dateTime{
//   date:Date;
// }
export default function copyRightYear(): number {
	const dateYear = new Date();
	const copyRight = dateYear.getFullYear();
	return copyRight;
};
